/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function BoundingBox(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M208,96a16.01833,16.01833,0,0,0,16-16V48a16.01833,16.01833,0,0,0-16-16H176a16.01833,16.01833,0,0,0-16,16v8H96V48A16.01833,16.01833,0,0,0,80,32H48A16.01833,16.01833,0,0,0,32,48V80A16.01833,16.01833,0,0,0,48,96h8v64H48a16.01833,16.01833,0,0,0-16,16v32a16.01833,16.01833,0,0,0,16,16H80a16.01833,16.01833,0,0,0,16-16v-8h64v8a16.01833,16.01833,0,0,0,16,16h32a16.01833,16.01833,0,0,0,16-16V176a16.01833,16.01833,0,0,0-16-16h-8V96Zm-24,64h-8a16.01833,16.01833,0,0,0-16,16v8H96v-8a16.01833,16.01833,0,0,0-16-16H72V96h8A16.01833,16.01833,0,0,0,96,80V72h64v8a16.01833,16.01833,0,0,0,16,16h8Z" />
    </Svg>
  );
}

export default BoundingBox;
